"use strict";

angular
	.module('rmTemplate')
	.factory('Template', require('./template.js'))
	.factory('TemplateItem', require('./templateitem.js'));
